import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetsLibraryComponent } from './assets-library.component';
import { AssetsTableComponent } from './components/assets-table/assets-table.component';
import { UploadAssetComponent } from './components/upload-asset/upload-asset.component';
import { SharedModule } from '../../shared/shared.module';
import { CoreModule } from '../../core/core.module';
import { ObserveVisibilityDirective } from "../../shared/directives/observe-visibility/observe-visibility.directive";
import { ScaleImgToCanvasDirective } from "../../shared/directives/scale-img-to-canvas/scale-img-to-canvas.directive";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        CoreModule
    ],
  declarations: [
    AssetsLibraryComponent,
    AssetsTableComponent,
    UploadAssetComponent,
    ObserveVisibilityDirective,
    ScaleImgToCanvasDirective
  ],
  exports: [
    AssetsLibraryComponent,
    AssetsTableComponent,
    UploadAssetComponent,
    ObserveVisibilityDirective,
    ScaleImgToCanvasDirective
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class AssetsLibraryModule { }
